import { wizardStepsConfig as F } from "../components/WizardStepsSummary/WizardStepsSummary.utils.js";
import { normalizePhoneNumber as z, phoneValidator as b } from "./phone.js";
import { EmploymentStatus as k, Utility as f, UtilityResponsiblePartyRoleType as T, MaritalStatus as H, IncomeFrequency as j, PetSex as G, isProd as Z, UnitApplicationWizardStep as x, ApplicationType as W, ApplicationStatus as O, UnitApplicationStatus as J, RenewalStatus as Q } from "@propify-tenant-client/services";
import K from "lodash/capitalize";
import X from "lodash/pick";
import i from "moment";
import p from "query-string";
import * as s from "yup";
const ee = /(((^https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%\/.\w-_]*)?\??[-+=&;%@.\w_]*#?[\w]*)?)$/, ge = (e) => ee.test(e), ye = (e) => !Number.isNaN(parseInt(e, 10)), qe = () => {
  const { hostname: e } = window.location;
  return e === "localhost" || e === "127.0.0.1";
}, Te = (e) => e instanceof Array ? e[0] : e, ve = (e) => e.toLowerCase().replace(/\s+(\w)?/gi, (r, t) => t.toUpperCase()), re = [".", ",", "!", "?", "'", "{", "}", "(", ")", "[", "]", "/"], _ = (e) => e === " ", se = (e, r) => re.indexOf(r[e]) >= 0 && _(r[e + 1]), w = (e, r, t, d) => e < t && e > d && se(e, r), be = (e, r = 80, t = 100, d = 200) => {
  if (d < r || t > d || t < r)
    throw new Error(
      "The minimum length must be less than the maximum, and the ideal must be between the minimum and maximum."
    );
  if (e.length < t)
    return [e, ""];
  let u = t, h = t, n, o;
  const g = (y) => {
    _(e[y]) && (n = n || y);
  };
  for (; u < d || h > r; ) {
    if (w(u, e, d, r)) {
      o = u + 1;
      break;
    } else if (w(h, e, d, r)) {
      o = h + 1;
      break;
    } else
      g(u), g(h);
    u++, h--;
  }
  return o === void 0 && (n && n >= r && n <= d ? o = n : t - r < d - t ? o = r : o = d), [e.slice(0, o), e.slice(o).trim()];
}, le = (e, r) => {
  const t = [];
  for (let d = 0; d < e.length; d++)
    d % r === 0 && t.push(e.slice(d, d + r));
  return t;
}, te = (e = []) => [...e].sort((r, t) => r.rank - t.rank), Pe = (e = []) => te(e).filter((r) => r.url)[0], Ee = (e) => e ? `${e.city}, ${e.state} ${e.postalCode}` : "", Se = (e, r = !1) => {
  if (!e)
    return "";
  const t = e.addr2 ? ` ${e.addr2}` : "", d = `${e.addr1}${t}`;
  return r ? d : `${d}, ${e.city}, ${e.state} ${e.postalCode}`;
}, Ae = (e, r) => {
  const t = "?" + p.stringify({
    unitId: e,
    redirect: window.location.href
  });
  if (!r.phoneVerified)
    return `/account/verification/sms${t}`;
  if (!r.qualifiedLead)
    return `/lead-qualification-form${t}`;
  if (!r.paymentVerified)
    return `/almost${t}`;
  if (!r.identityVerified)
    return `/account/verification/persona${t}`;
}, De = (e) => e == null ? "" : `${Number(e).toFixed(2)}%`, Ie = 10, Ne = (e) => +(e / 1048576).toFixed(1), ce = (e) => e ? e.trim().split(/[\s_]+/).map((r) => K(r.toLocaleLowerCase())).join(" ") : "", Ce = (e, r) => {
  if (!e || !r)
    return null;
  const { displayName: t } = (e == null ? void 0 : e.find((d) => d.value === r)) || {};
  return t || null;
}, Ve = () => Z() ? "https://www.nationalhomerentals.com/find-a-property/#/" : `${window.location.origin}/find-a-property.html#/`, ae = ({
  fullBathroomCount: e = 0,
  halfBathroomCount: r = 0,
  quarterBathroomCount: t = 0,
  threeQuarterBathroomCount: d = 0
}) => e + d + 0.5 * r + 0.25 * t, de = (e, r = "displayName", t = "value", d = []) => ({
  label: e[r],
  value: e[t],
  ...d.length ? { meta: X(e, d) } : {}
}), Oe = (e) => (e || []).map((r) => de(r)), R = s.string().required("This field is required").max(50, "Address too long").matches(
  /^[0-9 .,'\-()]*[a-zA-Z]+[a-zA-Z0-9 .,'\-()]*$/,
  "It must contains at least one letter.Only letters, numbers, space, dot, comma, single quote, hyphen and parenthesis are valid."
), M = s.string().required("This field is required").matches(
  /^[a-zA-Z .,'\-()]+$/,
  "Only letters, space, dot, comma, single quote, hyphen and parenthesis are valid"
), $ = s.string().required("This field is required").test("length", "This field should have 5 or 9 characters", (e) => {
  if (!e)
    return !0;
  const r = e.replaceAll(/\D/g, "");
  return r.length === 5 || r.length === 9;
}), B = s.string().required("This field is required").test("Date", "Please choose a valid date ", (e) => i(e).year() <= 2999), v = B.test(
  "NotInFuture",
  "Date must be in the past",
  (e) => i(e).isBefore(i())
), L = s.number().required("This field is required").positive("Value must be positive a number").min(1, "This field should be in the range of 1 to 100.000").max(1e5, "This field should be in the range of 1 to 100.000").test("Rent or Mortgage Payment", "Only 2 decimal points allowed", (e) => {
  if (!e)
    return !0;
  const [, r] = e.toString().split(".");
  return r ? r.length <= 2 : !0;
}), we = s.object().shape({
  addr1: R,
  city: M,
  state: s.string().required("This field is required"),
  country: s.string().min(2, "too short").max(2, "too long").required("This field is required"),
  zipCode: $,
  moveInDate: v,
  monthlyRentOrMortgagePaymentAmount: L,
  moveInDatePrev: s.string().when("iDoNotHaveAPreviousAddress", {
    is: (e) => !e,
    then: () => v,
    otherwise: (e) => e
  }),
  moveOutDatePrev: s.string().when("iDoNotHaveAPreviousAddress", {
    is: (e) => !e,
    then: () => v,
    otherwise: (e) => e
  }),
  addr1Prev: s.string().when("iDoNotHaveAPreviousAddress", {
    is: (e) => !e,
    then: () => R,
    otherwise: (e) => e
  }),
  monthlyRentOrMortgagePaymentAmountPrev: s.number().when("iDoNotHaveAPreviousAddress", {
    is: (e) => !e,
    then: () => L,
    otherwise: (e) => e
  }),
  cityPrev: s.string().when("iDoNotHaveAPreviousAddress", {
    is: (e) => !e,
    then: () => M,
    otherwise: (e) => e
  }),
  statePrev: s.string().when("iDoNotHaveAPreviousAddress", {
    is: (e) => !e,
    then: (e) => e.required("This field is required"),
    otherwise: (e) => e
  }),
  countryPrev: s.string().when("iDoNotHaveAPreviousAddress", {
    is: (e) => !e,
    then: (e) => e.min(2, "too short").max(2, "too long").required("This field is required"),
    otherwise: (e) => e
  }),
  zipCodePrev: s.string().when("iDoNotHaveAPreviousAddress", {
    is: (e) => !e,
    then: () => $,
    otherwise: (e) => e
  })
}), Re = (e, r, t) => {
  var d, u;
  return {
    leaseTerm: (r == null ? void 0 : r.leaseTerm) || (t == null ? void 0 : t.leaseTerm) || 12,
    moveInDate: (r == null ? void 0 : r.moveInDate) || (t == null ? void 0 : t.startDate),
    firstName: e == null ? void 0 : e.firstName,
    middleName: e == null ? void 0 : e.middleName,
    nameSuffix: e == null ? void 0 : e.nameSuffix,
    lastName: e == null ? void 0 : e.lastName,
    dateOfBirth: e == null ? void 0 : e.person.dateOfBirth,
    maritalStatus: e == null ? void 0 : e.person.maritalStatus,
    usingVoucher: r == null ? void 0 : r.usingVoucher,
    emergencyContactName: (d = e == null ? void 0 : e.emergencyContact) == null ? void 0 : d.name,
    emergencyContactPhoneNumber: (u = e == null ? void 0 : e.emergencyContact) == null ? void 0 : u.phoneNumber
  };
};
function Me(e) {
  const r = F.find((t) => t.hash === e);
  return r ? r.value : x.APPLICATION_DETAILS;
}
const $e = s.object().shape({
  ownVehicles: s.string().required("This field is required"),
  vehicles: s.array().when("ownVehicles", {
    is: (e) => e === "YES",
    then: (e) => e.of(
      s.object().shape({
        make: s.string().required("This field is required"),
        model: s.string().required("This field is required"),
        year: s.number().min(1901, "Invalid year").max(i().year(), "Invalid year").required("This field is required!"),
        color: s.string().required("This field is required").matches(/^[A-Za-z]+$/, "Must be only letters"),
        licensePlate: s.string().required("This field is required"),
        state: s.string().required("This field is required")
      })
    )
  })
});
function m(e) {
  if (e !== void 0)
    return e ? "YES" : "NO";
}
const Le = (e, r) => ({
  ownVehicles: m(e ? e.hasVehicles : r == null ? void 0 : r.hasVehicles),
  vehicles: e && e.vehicles.length > 0 ? e.vehicles : r && r.vehicles.length > 0 ? r.vehicles : [
    {
      make: "",
      model: "",
      color: "",
      licensePlate: "",
      state: "",
      year: void 0
    }
  ]
}), Ue = s.object().shape({
  over18: s.string().required("This field is required"),
  minors: s.string().required("This field is required"),
  occupants: s.array().when("minors", {
    is: (e) => e === "YES",
    then: (e) => e.of(
      s.object().shape({
        dateOfBirth: s.date().required("This field is required").min(i().subtract(18, "years").toDate(), "Must be 17 years or younger").max(
          i().endOf("day").add(1, "year").toDate(),
          "Date of birth can be up to one year in the future"
        )
      })
    )
  })
}), Ye = (e, r) => {
  const t = e ?? r;
  return {
    over18: t != null && t.applications.some(
      (d) => d.type !== W.PRIMARY
    ) ? "YES" : m(t == null ? void 0 : t.hasApplications),
    minors: m(t == null ? void 0 : t.hasOccupants),
    occupants: t ? t.occupants.length > 0 ? t.occupants : [
      {
        unitApplicationId: e == null ? void 0 : e.id,
        dateOfBirth: ""
      }
    ] : []
  };
}, _e = s.object().shape({
  employmentStatus: s.string().required("This field is required"),
  currentEmployer: s.object().when("employmentStatus", {
    is: (e) => e === k.EMPLOYED,
    then: (e) => e.shape({
      employer: s.string().required("This field is required"),
      jobTitle: s.string().required("This field is required"),
      monthlyIncome: s.number().min(1, "Value must be higher than 0").required("This field is required"),
      employmentStartDate: s.string().required("This field is required"),
      supervisorName: s.string().required("This field is required"),
      phoneNumber: s.string().test(
        "is-number",
        "Invalid Phone number",
        (r, t) => b(r, t.parent.countryCode)
      ).required("This field is required"),
      addr1: s.string().required("This field is required"),
      country: s.string().required("This field is required"),
      state: s.string().required("This field is required"),
      postalCode: s.string().required("This field is required"),
      city: s.string().required("This field is required")
    })
  }),
  previousEmployer: s.object().when("dontHavePreviousEmployment", {
    is: (e) => !e,
    then: (e) => e.shape({
      employer: s.string().required("This field is required"),
      jobTitle: s.string().required("This field is required"),
      monthlyIncome: s.number().min(1, "Value must be higher than 0").required("This field is required"),
      employmentStartDate: s.string().required("This field is required"),
      employmentEndDate: s.string().required("This field is required"),
      phoneNumber: s.string().test("is-number", "Invalid Phone number", (r, t) => (r || "").replace(/^\+1/, "").replace(/\D/g, "") ? z(r, t.parent.countryCode) ? b(r, t.parent.countryCode) : !1 : !0),
      addr1: s.string().required("This field is required"),
      country: s.string().required("This field is required"),
      state: s.string().required("This field is required"),
      postalCode: s.string().required("This field is required"),
      city: s.string().required("This field is required")
    })
  }),
  haveAdditionalIncome: s.string().required("This field is required"),
  additionalIncome: s.object().when("haveAdditionalIncome", {
    is: (e) => e === "YES",
    then: (e) => e.shape({
      amount: s.number().min(1, "Value must be higher than 0").required("This field is required"),
      frequency: s.string().required("This field is required"),
      source: s.string().required("This field is required")
    })
  })
}), Be = (e) => {
  var r, t, d, u, h, n, o, g, y, l, P, E, S, A, D, I, N, c, C, V, a;
  return {
    addr1: ((r = e == null ? void 0 : e.currentAddress) == null ? void 0 : r.addr1) || "",
    city: ((t = e == null ? void 0 : e.currentAddress) == null ? void 0 : t.city) || "",
    zipCode: ((d = e == null ? void 0 : e.currentAddress) == null ? void 0 : d.postalCode) || "",
    country: ((u = e == null ? void 0 : e.currentAddress) == null ? void 0 : u.country) || "US",
    state: ((h = e == null ? void 0 : e.currentAddress) == null ? void 0 : h.state) || "",
    monthlyRentOrMortgagePaymentAmount: (n = e == null ? void 0 : e.currentAddress) == null ? void 0 : n.monthlyRentOrMortgagePaymentAmount,
    was30DaysNoticeGiven: (o = e == null ? void 0 : e.currentAddress) != null && o.was30DaysNoticeGiven ? "yes" : "no",
    moveInDate: ((g = e == null ? void 0 : e.currentAddress) == null ? void 0 : g.moveInDate) || "",
    reasonForMoving: ((y = e == null ? void 0 : e.currentAddress) == null ? void 0 : y.reasonForMoving) ?? "",
    addr1Prev: ((l = e == null ? void 0 : e.previousAddress) == null ? void 0 : l.addr1) || "",
    cityPrev: ((P = e == null ? void 0 : e.previousAddress) == null ? void 0 : P.city) || "",
    zipCodePrev: ((E = e == null ? void 0 : e.previousAddress) == null ? void 0 : E.postalCode) || "",
    countryPrev: ((S = e == null ? void 0 : e.previousAddress) == null ? void 0 : S.country) || "US",
    statePrev: ((A = e == null ? void 0 : e.previousAddress) == null ? void 0 : A.state) || "",
    monthlyRentOrMortgagePaymentAmountPrev: (D = e == null ? void 0 : e.previousAddress) == null ? void 0 : D.monthlyRentOrMortgagePaymentAmount,
    was30DaysNoticeGivenPrev: (I = e == null ? void 0 : e.previousAddress) != null && I.was30DaysNoticeGiven ? "yes" : "no",
    reasonForMovingPrev: ((N = e == null ? void 0 : e.previousAddress) == null ? void 0 : N.reasonForMoving) ?? "",
    moveInDatePrev: ((c = e == null ? void 0 : e.previousAddress) == null ? void 0 : c.moveInDate) || "",
    moveOutDatePrev: ((C = e == null ? void 0 : e.previousAddress) == null ? void 0 : C.moveOutDate) || "",
    iDoNotHaveAPreviousAddress: (e == null ? void 0 : e.hasPreviousAddress) === !1,
    owned: !!((V = e == null ? void 0 : e.currentAddress) != null && V.owned),
    ownedPrev: !!((a = e == null ? void 0 : e.previousAddress) != null && a.owned)
  };
}, q = s.string().matches(
  /^[a-zA-Z .'\-]+$/,
  "Only letters, space, dot, single quote and hyphen are valid"
), Fe = (e = !0) => s.object().shape({
  leaseTerm: s.number().min(1, "Lease terms should be between 1 and 999 months").max(999, "Lease terms should be between 1 and 999 months").required("This field is required"),
  ...e ? {
    moveInDate: B.test(
      "Date",
      "This date can't be in the past",
      (r) => i(r).startOf("day").isSameOrAfter(i().startOf("day"))
    )
  } : {},
  firstName: q.required("This field is required").min(2, "First name too short"),
  middleName: q,
  lastName: q.required("This field is required").min(2, "Last name too short"),
  nameSuffix: s.string().nullable(),
  dateOfBirth: s.string().required("This field is required").test("dob", "Should be greater than or equal to 18 years", function(r) {
    return i().diff(r, "years") >= 18;
  }),
  maritalStatus: s.string().required("This field is required").test(
    "is-unknown",
    "This field is required",
    (r) => r !== "" && r !== H.UNKNOWN
  ),
  emergencyContactName: q.min(2, "Name too short"),
  emergencyContactPhoneNumber: s.string().when("emergencyContactName", {
    is: (r) => (r == null ? void 0 : r.length) > 0,
    then: (r) => r.test(
      "is-number",
      "Invalid Phone number",
      (t, d) => b(t, d.parent.countryCode)
    ).required("This field is required")
  })
}), U = (e) => ({
  ...e,
  country: e.country === "US" ? "US" : "OTHER",
  customCountry: e.country !== "US" ? e.country : ""
}), Y = {
  employer: "",
  jobTitle: "",
  employmentStartDate: "",
  employmentEndDate: "",
  supervisorName: "",
  phoneNumber: "",
  addr1: "",
  country: "US",
  customCountry: "",
  state: "",
  postalCode: "",
  city: ""
}, ze = (e) => ({
  employmentStatus: e == null ? void 0 : e.employmentStatus,
  currentEmployer: e != null && e.currentEmployer ? U(e == null ? void 0 : e.currentEmployer) : Y,
  previousEmployer: e != null && e.previousEmployer ? U(e == null ? void 0 : e.previousEmployer) : Y,
  dontHavePreviousEmployment: (e == null ? void 0 : e.hasPreviousEmployer) === !1,
  haveAdditionalIncome: m(e == null ? void 0 : e.hasAdditionalIncome),
  additionalIncome: e != null && e.additionalIncome ? e == null ? void 0 : e.additionalIncome : {
    source: "",
    frequency: j.MONTHLY
  }
}), ke = (e, r) => ({
  ownPets: m(e ? e.hasPets : r == null ? void 0 : r.hasPets),
  pets: e && e.pets.length > 0 ? e.pets : r && r.pets.length > 0 ? r.pets : [
    {
      name: "",
      type: void 0,
      breed: "",
      color: "",
      sex: G.MALE,
      spayedNeutered: !1,
      serviceAnimal: !1
    }
  ]
}), He = s.object().shape({
  ownPets: s.string().required("This field is required"),
  pets: s.array().when("ownPets", {
    is: (e) => e == "YES",
    then: (e) => e.of(
      s.object().shape({
        name: s.string().required("This field is required"),
        type: s.string().required("This field is required"),
        breed: s.string().when("type", {
          is: (r) => r !== "OTHER",
          then: (r) => r.required("This field is required")
        }).nullable(),
        species: s.string().when("type", {
          is: (r) => r === "OTHER",
          then: (r) => r.required("This field is required")
        }).nullable(),
        weight: s.number().required("This field is required"),
        age: s.number().required("This field is required"),
        color: s.string().required("This field is required"),
        sex: s.string().required("This field is required"),
        spayedNeutered: s.boolean().required("This field is required"),
        serviceAnimal: s.boolean().required("This field is required")
      })
    )
  })
}), je = "1900-01-01";
function Ge(e) {
  return e === "YES";
}
const Ze = {
  REQUESTED: "#8A8A8A",
  SUBMITTED: "#FFCC49",
  ACCEPTED: "#00C62B",
  REJECTED: "#FF0000"
}, xe = {
  REQUESTED: void 0,
  SUBMITTED: "Your file has been uploaded and is pending approval.",
  ACCEPTED: "Your file has been approved.",
  REJECTED: "Your file has been rejected."
}, We = {
  [f.ELECTRICITY]: "Electricity",
  [f.WATER]: "Water",
  [f.GAS]: "Gas",
  [f.INTERNET_CABLE]: "Internet/Cable",
  [f.SEWAGE]: "Sewage",
  [f.GARBAGE]: "Garbage"
}, Je = {
  [T.PROPERTY_MANAGER]: "Property Manager",
  [T.RESIDENT]: "Resident",
  [T.DOES_NOT_APPLY]: "Doest not Apply"
}, Qe = s.object().shape({
  ssn: s.string().required("This field is required").test("validFormat", "Invalid SSN", (e) => !e || e === "___-__-____" ? !0 : /^\d{3}-?\d{2}-?\d{4}$/.test(e)),
  agreeToTerms: s.boolean().oneOf([!0], "You need to check this to continue"),
  acknowledgeInformationCorrect: s.boolean().oneOf([!0], "You need to check this to continue")
}), Ke = (e, r, t) => !!e && ((r == null ? void 0 : r.applicationStatus) === O.APPROVED || (r == null ? void 0 : r.status) === J.APPROVED || (t == null ? void 0 : t.applicationStatus) === O.APPROVED || (t == null ? void 0 : t.status) === Q.ACCEPTED);
export {
  je as DATE_MIN_VALUE,
  We as UtilityLabels,
  Je as UtilityResponsiblePartyRoleTypeLabels,
  we as addressValidationSchema,
  Ne as bytesToMegaBytes,
  Ue as coSignersValidationSchema,
  Ze as colorByApplicationFileStatus,
  Me as convertHashToStep,
  _e as employmentValidationSchema,
  Oe as enumToOptions,
  De as formatPercentage,
  Ee as getAddressCityStateAndPostal,
  Se as getAddressDescription,
  Be as getAddressInitialValues,
  Re as getApplicationDetailsInitialValues,
  Fe as getApplicationDetailsValidationSchema,
  ae as getBathroomCount,
  Ye as getCoSignersInitialValues,
  ze as getEmploymentInitialValues,
  Ce as getEnumLabel,
  Te as getFirst,
  Pe as getFirstImage,
  ke as getPetsInitialValues,
  Ve as getSearchPropertiesURL,
  Ae as getValidationRoute,
  Le as getVehiclesInitialValues,
  xe as helperTextByApplicationFileStatus,
  qe as isLocalhost,
  ye as isNumber,
  ge as isUrl,
  ve as labelToEnum,
  Ie as maxFileSizeInMB,
  Ge as parseYesNoToBoolean,
  le as partitionArray,
  He as petsValidationSchema,
  Qe as screeningInformationValidationSchema,
  Ke as showLeaseTermsStep,
  ce as transformSnakeCaseToCapitalizedWords,
  be as trimText,
  $e as vehiclesValidationSchema
};
//# sourceMappingURL=utils.js.map
